@if (chips.length > 0) {
  <div class="active-filters-bar">
    <span class="active-filters-label">Active filters:</span>
    @for (chip of chips; track chip) {
      <span class="filter-chip">
        <span class="chip-label">{{ chip.label }}:</span>
        <span class="chip-value">{{ chip.value }}</span>
        <button
          class="chip-clear"
          (click)="clearChip.emit(chip.key)"
          [attr.aria-label]="'Clear ' + chip.label + ' filter'"
          type="button">
          ×
        </button>
      </span>
    }
    <button class="clear-all-chips" (click)="clearAll.emit()" type="button">
      Clear all
    </button>
  </div>
}
